import { useNavigate } from 'react-router-dom'
import DealsAGTable from '../components/dealsAG-table/DealsAGTable'

function DealsPageWrapper() {
  const navigate = useNavigate()
  return (
    <>
      <div className='d-flex justify-content-between'>
        <div className='d-flex justify-content-start align-items-center my-4'>
          <div className='d-flex flex-column'>
            <div className='d-flex align-items-baseline border-4 border-start border-primary ps-4'>
              <div>
                <h2 className='mb-0 fw-bold'>Contracts</h2>
                <p className='fs-8 mb-0 text-gray-500'>My Documents</p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <button
            className='btn btn-md btn-primary fs-base fw-bold'
            onClick={() => {
              navigate('/contracts/templateViewer', { state: { defaultOption: 'issue' } })
            }}
          >
            Add Document
          </button>
        </div>
      </div>
      <div className='card rounded-5 my-10'>
        <DealsAGTable />
      </div>
    </>
  )
}

export default DealsPageWrapper
